import { PROFESSIONAL_SECTIONS_ANCHOR } from '~/modules/professional/util/constants';

interface RangeProfessional {
    Link: string;
    URLSegment: string;
}

/**
 * Build a professional products URL filtered to a product range.
 */
export const getProductRangeUrl = (
    professional: RangeProfessional,
    rangeName: string,
): string => {
    const professionalProducts = `${professional.Link}/our-products`;
    const searchParams = new URLSearchParams();

    if (rangeName) {
        searchParams.set('productRanges', rangeName);
    }

    if (professional.URLSegment) {
        searchParams.set('professionals', professional.URLSegment);
    }

    const rangeParams = searchParams.toString();

    return rangeParams
        ? `${professionalProducts}?${rangeParams}#${PROFESSIONAL_SECTIONS_ANCHOR}`
        : professionalProducts;
};
